import React, { useState } from 'react';
import { db, storage } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const OrgMessageWriter = ({ organizationId, onSuccess }) => {
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [link, setLink] = useState('');
  const [linkText, setLinkText] = useState('');
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let imageUrl = null;

      // Upload image if one is selected
      if (image) {
        const imageRef = ref(storage, `organizations/${organizationId}/messages/${Date.now()}_${image.name}`);
        await uploadBytes(imageRef, image);
        imageUrl = await getDownloadURL(imageRef);
      }

      // Create the message
      await addDoc(collection(db, 'organizations', organizationId, 'messages'), {
        title,
        text,
        link: link || null,
        linkText: linkText || null,
        imageUrl,
        createdAt: serverTimestamp(),
      });

      // Reset form
      setTitle('');
      setText('');
      setLink('');
      setLinkText('');
      setImage(null);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
      if (typeof onSuccess === 'function') onSuccess();
    } catch (error) {
      console.error('Error creating message:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">
        Announcement to all Members
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Title
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#5ABA47] focus:ring-[#5ABA47]"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Message
          </label>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={4}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#5ABA47] focus:ring-[#5ABA47]"
            required
          />
          <p className="mt-2 text-sm text-gray-500">
            This announcement will be posted on the My Community page for all members to see.
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Link (optional)
          </label>
          <input
            type="url"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#5ABA47] focus:ring-[#5ABA47]"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Link Text (optional)
          </label>
          <input
            type="text"
            value={linkText}
            onChange={(e) => setLinkText(e.target.value)}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#5ABA47] focus:ring-[#5ABA47]"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Image (optional)
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
            className="w-full"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-2 px-4 rounded-md text-white ${
            loading 
              ? 'bg-gray-400' 
              : 'bg-[#5ABA47] hover:bg-[#4a9939]'
          } transition-colors`}
        >
          {loading ? 'Creating...' : 'Create Message'}
        </button>

        {success && (
          <div className="text-[#5ABA47] text-center">
            Message created successfully!
          </div>
        )}
      </form>
    </div>
  );
};

export default OrgMessageWriter; 